import { Injectable } from '@angular/core';
import { MainService } from "./main.service";
import { HttpClient } from "@angular/common/http";
import { ToastService } from 'src/app/services/toast.service';
import { StorageService } from 'src/app/services/storage.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class OrderService extends MainService {

	order: any = null;

	/* just added this here kasi nawawala yung value ng mga variables na to sa messaging.component.ts file if callinjg a function */
	fileName: any = null;
	file: any = null;
	attachmentName: any;
	constructor(
		public http: HttpClient,
		public toastService: ToastService,
		public storage: StorageService,
		public router: Router,
	) {
		super(http, toastService, storage, router);
	}

	/**
	 * get the order from magento API
	 */ 
	getOrder(orderId){
		return new Promise(res => {
			


			this.makeRequest('/rest/entrelable/V1/hnd-order/elorder/'+orderId, null, 'GET').then((resolve:any) => {
				this.order = resolve[0];
				res(resolve[0]);
			});

			// this.makeRequest('/rest/entrelable/V1/lns-api/orders/'+orderId, null, 'GET').then(resolve => {
			// 	this.order = resolve;
			// 	res(resolve);
			// });
		});
	}

	/**
	 * this method can will get the order by increment id 
	 * can get even not loged in
	 * @returns 
	 */
	getByIncrementId(incrementId:string=''){
		return new Promise(res => {
			let url = this.getStoreUrl('/V1/hnd-order/order/' + incrementId);
			this.doRequest(url, null, 'GET', true, false).then((result:any) => {
				if(!result.error && result.result){
					res(result.result);
				} else {
					res(null);
				}
			});
		});
	}

	

	/**
	 * sync the order from other stores
	 * this is because of social media login for account created 
	 * before 5-11-2022 9:00 pm
	 */
	syncOrdersPlacedViaSocialLogin(){
		return new Promise(res => {
			this.makeRequest(this.getStoreUrl('/V1/lns-sociallogin/customer/order/sync'), {}, 'POST')
			.then(synced => {
				res(synced);
			});
		});
	}
}
